import React from 'react';

import { StatsOverviewContainer } from '@pages/stats-overview/StatsOverview.container';

export const StatsOverviewBetaPage = React.memo(() => <StatsOverviewContainer />);
